// extracted by mini-css-extract-plugin
export var loc = "Title-module--loc--60c68";
export var optional = "Title-module--optional--25a88";
export var title = "Title-module--title--476aa";
export var tooltip = "Title-module--tooltip--12fb8";